'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { Member } from './team';

export function MemberCard({ member }: { member: Member }) {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-5 sm:gap-6">
      <Image
        src={member?.image?.url}
        alt={resolveImageAlt(member?.image, member?.name)}
        width={0}
        height={0}
        className="h-[300px] w-full object-cover object-center sm:h-[330px]"
        sizes="100vw"
      />
      <div className="flex w-full flex-col items-start justify-start gap-2 sm:gap-3">
        <h5 className="font-oswald text-lg font-bold uppercase text-black sm:text-xl lg:text-2xl">
          {member.name} {member.surname}
        </h5>
        <p className="upper text-sm font-medium text-black sm:text-base">{member.role}</p>
      </div>
    </div>
  );
}
